export enum AudioFeatureType {
	BRIEFING = 'briefing',
	NARRATION = 'narration',
}
